"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpDataTableCell = void 0;
const lodash_1 = require("lodash");
const vue_1 = __importDefault(require("vue"));
const vue_property_decorator_1 = require("vue-property-decorator");
const column_1 = require("./column");
const cell_html_1 = __importDefault(require("./cell.html"));
const row_model_1 = require("./model/row-model");
function focusable(component) {
    return (0, lodash_1.isFunction)((0, lodash_1.get)(component, 'focus'));
}
function selectable(component) {
    return (0, lodash_1.isFunction)((0, lodash_1.get)(component, 'select'));
}
let ItpDataTableCell = class ItpDataTableCell extends vue_1.default {
    editingValue;
    col;
    row;
    formId;
    value;
    noTableEdit;
    globs;
    messages;
    editing;
    autofocus;
    validationState;
    validationErrorMessage;
    onValueChanged(newValue) {
        if (this.editing && this.editingValue !== newValue) {
            this.beginEditValue(newValue);
        }
    }
    onEditingChanged(newValue) {
        if (newValue) {
            this.beginEditValue(this.value);
        }
    }
    beginEditValue(value) {
        this.editingValue = value;
    }
    data() {
        return {
            editingValue: this.value
        };
    }
    focus() {
        this.$nextTick(() => {
            const el = this.findFirstFocusableComponent(this);
            if (!el) {
                console.warn('Cannot find focusable element.');
                return false;
            }
            el.focus();
            if (selectable(el)) {
                el.select();
            }
        });
    }
    findFirstFocusableComponent(element) {
        for (let c of element.$children) {
            if (focusable(c)) {
                return c;
            }
            let result = this.findFirstFocusableComponent(c);
            if (result) {
                return result;
            }
        }
    }
    get className() {
        return [
            'itp-datatable__table-cell',
            'position-relative',
            this.col.getCellClass(this.editing, this.row)
        ];
    }
    get headerClassName() {
        return [
            'cell-header',
            'text-muted',
            'text-uppercase',
            this.col.getCellHeaderClass()
        ];
    }
    get isEditable() {
        return !this.col.readonly && this.col.editable;
    }
    get showEditorSlot() {
        return this.isEditable && this.editing;
    }
    get currentValue() {
        return this.editing ? this.editingValue : this.value;
    }
    get displayHeader() {
        const columnHeaderStyle = this.col.owner.model.options.columnHeaderStyle;
        if (columnHeaderStyle === 'cellHeader') {
            return true;
        }
        if (columnHeaderStyle === 'cellheaderWhenEditing' && this.editing) {
            return true;
        }
        return false;
    }
    set currentValue(value) {
        this.editingValue = value;
        this.$emit('input', value);
    }
    setValue(value) {
        this.currentValue = value;
    }
};
exports.ItpDataTableCell = ItpDataTableCell;
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", column_1.ColumnDefinition)
], ItpDataTableCell.prototype, "col", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", row_model_1.RowModel)
], ItpDataTableCell.prototype, "row", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", String)
], ItpDataTableCell.prototype, "formId", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", Object)
], ItpDataTableCell.prototype, "value", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean }),
    __metadata("design:type", Boolean)
], ItpDataTableCell.prototype, "noTableEdit", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", Object)
], ItpDataTableCell.prototype, "globs", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", Object)
], ItpDataTableCell.prototype, "messages", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean }),
    __metadata("design:type", Boolean)
], ItpDataTableCell.prototype, "editing", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean }),
    __metadata("design:type", Boolean)
], ItpDataTableCell.prototype, "autofocus", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", Boolean)
], ItpDataTableCell.prototype, "validationState", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpDataTableCell.prototype, "validationErrorMessage", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('value'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ItpDataTableCell.prototype, "onValueChanged", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('editing'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ItpDataTableCell.prototype, "onEditingChanged", null);
exports.ItpDataTableCell = ItpDataTableCell = __decorate([
    (0, vue_property_decorator_1.Component)({ template: cell_html_1.default })
], ItpDataTableCell);
//# sourceMappingURL=cell.js.map